import bocconi from './bocconi.png';
import built_logo_ext from './built_logo_ext.png';
export default {
	bocconi,
	built_logo_ext
};
